import { LeftMenuStructure } from "../store";
import { LEFT_MENU } from "../actions-constants/leftMenu.constants";

const initialLeft:LeftMenuStructure = new LeftMenuStructure();

export function leftMenuReducer(leftMenu: LeftMenuStructure = initialLeft,action):LeftMenuStructure {
    switch(action.type) {
        case LEFT_MENU.SHOW:
            return {...leftMenu,show: action.show}
        case LEFT_MENU.TOGGLE:
                return {...leftMenu,show: !leftMenu.show}
        default:
            return leftMenu
    }
}